"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMilestoneRequestToJSON = exports.CreateMilestoneRequestFromJSONTyped = exports.CreateMilestoneRequestFromJSON = void 0;
function CreateMilestoneRequestFromJSON(json) {
    return CreateMilestoneRequestFromJSONTyped(json, false);
}
exports.CreateMilestoneRequestFromJSON = CreateMilestoneRequestFromJSON;
function CreateMilestoneRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': json['target'],
        'rewardConfigId': json['rewardConfigId'],
        'name': json['name'],
    };
}
exports.CreateMilestoneRequestFromJSONTyped = CreateMilestoneRequestFromJSONTyped;
function CreateMilestoneRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': value.target,
        'rewardConfigId': value.rewardConfigId,
        'name': value.name,
    };
}
exports.CreateMilestoneRequestToJSON = CreateMilestoneRequestToJSON;
